/*
 Using a map for this works because JS guarantees iteration order of properties
 based on the order of creation. But it's definitely a weird way to represent
 ordered data.
 */
const sortsToOrder = map => {
    const qs = [];
    if (map != null) {
        for (const k of Object.keys(map)) {
            const v = map[k];
            qs.push(k + " " + v);
        }
    }
    return qs.join(",");
};

export default sortsToOrder;



// WEBPACK FOOTER //
// ./app/lib/sortsToOrder.js